import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class DynamicFieldsService {

  setError(fieldError: any, field: any): any {
    return (!_.isEmpty(fieldError) && !_.isEmpty(field) && fieldError[field.alias]) ? fieldError[field.alias] : {hasError: false, error: ''};
  }

  getFieldOptionValue(fieldsOptions: any, field: any, name: string, defaultValue: any): any {
    return _.get(fieldsOptions, field.alias + '.' + name, defaultValue);
  }

  isRequired(scope: any): boolean {
    const fieldName = _.get(scope, 'fieldName', _.get(scope, 'field.fieldName', _.get(scope, 'id', '')));
    const fieldOptions = _.get(scope, 'fieldsOptions.' + fieldName, _.get(scope, 'fieldOptions', _.get(scope, 'fieldSettings', {})));
    return _.get(fieldOptions, 'isRequired', false);
  }

  getNoneElement(): any {
    return {
      id: 100,
      label: 'None',
      alias: 'none'
    };
  }

  getWorkflowOptions(field: any, alias: string, workflow: any): any {
    const relatedField = _.cloneDeep(_.find(_.get(workflow, 'fields', []), { alias: alias }));
    const relatedElement = _.find(_.get(relatedField, 'fieldElements', []), { id: _.get(field, 'fieldData.id', 0) });
    const toElements = relatedElement?.toElements;

    if (toElements) {
      const _currentElement = { id: relatedElement.id, label: relatedElement.label, alias: relatedElement.alias };
      relatedField.fieldElements = relatedElement.toElements;
      relatedField.fieldElements.unshift(_currentElement);
    }

    return relatedField;
  }

  sortFieldElements(fieldOption: any): any {
    if (_.get(fieldOption, 'fieldElements', false)) {
      _.sortBy(fieldOption.fieldElements, ['label']);
    }
    return fieldOption;
  }

  getFieldOptions(fields: any, field: any, workflow: any = {}): any {
    const alias = field?.alias;
    if (!alias) return;

    const fieldOption = _.get(fields, alias);
    if (!fieldOption) return;

    if (field?.useWorkflow && _.get(field, 'fieldData.id', 100) != 100) {
      return this.getWorkflowOptions(field, alias, workflow);
    }

    return _.cloneDeep(fieldOption);
  }

  addNoneElement(fieldOption: any): any[] {
    const elements = _.get(fieldOption, 'fieldElements', []);
    const none = this.getNoneElement();
    if (_.get(elements, '[0].id') != none.id) {
      elements.unshift(none);
    }
    return elements;
  }
}
